import React from 'react';

var ArrowFirst = function ArrowFirst(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 1.414L12.414 12zM6 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 5v14H5V5h2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowFirst.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowFirst as icon };
export default iconHandler(ArrowFirst);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowFirst.js
// module id = 578
// module chunks = 0